module.exports = __webpack_public_path__ + "media/images/count-box-bg-light-purple-e5aca8cd.svg";